import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BannerContainer = styled.div.withConfig({
  displayName: "UpdateDateFilterWithTimezonesNotification__BannerContainer",
  componentId: "sc-1i3mvg1-0"
})(["margin-top:10px;margin-bottom:10px;"]);
const UpdateDateFilterWithTimezonesNotification = ({
  onUpdateClick,
  useUTC
}) => {
  return /*#__PURE__*/_jsx(BannerContainer, {
    children: /*#__PURE__*/_jsxs(UIAlert, {
      className: "p-x-2",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.dateFilterWithTimezones.title"
      }),
      type: "tip",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.dateFilterWithTimezones.text"
        }), !useUTC && /*#__PURE__*/_jsx(UIAlert, {
          className: "m-top-2 p-x-2",
          style: {
            minHeight: 'unset'
          },
          type: "warning",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.dateFilterWithTimezones.warning"
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIButton, {
          onClick: onUpdateClick,
          style: {
            paddingLeft: 0
          },
          use: "transparent",
          children: 'Update'
        })
      })]
    })
  });
};
UpdateDateFilterWithTimezonesNotification.propTypes = {
  onUpdateClick: PropTypes.func.isRequired
};
export default UpdateDateFilterWithTimezonesNotification;